import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./attachment-mng-list.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./attachment-mng-list.component.scss?ngResource";
import { ChangeDetectorRef, Component, forwardRef, Input, } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { of } from "rxjs";
import { DatePipe } from "@angular/common";
import { AttachmentManagerTableHeaderEnum, AttachmentManagerTableHeaderLookup, } from "../shared/models/attachment-manager-table-header.model";
import { AttachmentManagerService } from "../shared/services/attachment-manager.service";
import { PopUpComponent } from "../../pop-up/pop-up.component";
import { AttachmentManagerConstants } from "../shared/constants/attachment-manager.constant";
import { AttachemntMngView } from "../shared/models/attachment-mng-view";
import { AttachmentParentFormComponent } from "../attachment-parent-form/attachment-parent-form.component";
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR, } from "@angular/forms";
import { AttachmentManagerHelper } from "../shared/attachment-manager-helper";
import { SharedConstants } from "../../../constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../models/alert";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import { FileUtils } from "../../../utils/file-utils";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let AttachmentMngListComponent = class AttachmentMngListComponent {
    attachmentManagerService;
    appControllerService;
    modalService;
    datePipe;
    changeDetection;
    formBuilder;
    addBtn = SharedConstants.ADD_LABEL;
    removeBtn = SharedConstants.REMOVE_LABEL;
    editBtn = SharedConstants.EDIT_LABEL;
    attachmentListCtrl = AttachmentManagerConstants.ATTACHMENT_LIST_CTRL;
    dataSource$;
    urlText = AttachmentManagerTableHeaderEnum.link;
    componentType;
    attachmentType;
    jobId;
    hideAddAttachmentButton;
    hideDeleteAttachmentButton;
    anonymousAccess = { anonymousDocumentAccess: false };
    options = {
        size: "lg",
        centered: true,
        backdrop: "static",
        keyboard: false
    };
    tableHeader;
    selectedAttachments = [];
    selectedSavedAttachments = new Array();
    attachmentListForm;
    attachmentListSubscription;
    listenForNewAttachmentsSubscription;
    getAttachmentContentSubscription;
    listenForAttachmentListUpdateSubscription;
    emitClearAttachmentTable;
    get value() {
        return this.attachmentListForm.value;
    }
    set value(value) {
        this.onChange(value);
        this.onTouched();
    }
    get attachmentArrayCtrl() {
        return this.attachmentListForm.get(this.attachmentListCtrl);
    }
    constructor(attachmentManagerService, appControllerService, modalService, datePipe, changeDetection, formBuilder) {
        this.attachmentManagerService = attachmentManagerService;
        this.appControllerService = appControllerService;
        this.modalService = modalService;
        this.datePipe = datePipe;
        this.changeDetection = changeDetection;
        this.formBuilder = formBuilder;
    }
    ngOnInit() {
        this.listenForNewAttachments();
        this.listenForAttachmentListUpdate();
        this.tableHeader = AttachmentManagerTableHeaderLookup;
        this.initializeSelectedSavedAttachments();
        this.cleanAttachment();
        this.initForm();
        this.attachmentListSubscription = this.attachmentListForm.valueChanges.subscribe((value) => {
            this.onChange(value);
            this.onTouched();
        });
    }
    initForm() {
        if (this.anonymousAccess.anonymousCommentRequestAccess) {
            this.anonymousAccess.anonymousDocumentAccess = true;
        }
        this.attachmentListForm = this.formBuilder.group({
            attachmentList: this.formBuilder.array([])
        });
    }
    itemsChecked(array) {
        this.selectedAttachments = array;
    }
    onBtnAddClicked() {
        const dialogRef = this.modalService.open(AttachmentParentFormComponent, this.options);
        dialogRef.componentInstance.jobId = this.jobId;
        dialogRef.componentInstance.componentType = this.componentType;
        dialogRef.componentInstance.attachmentType = this.attachmentType;
        dialogRef.result
            .then((attachment) => {
            if (attachment) {
                this.addSelectedSavedAttachment(false, attachment);
                this.attachmentManagerService.addSavedAttachment(attachment);
                this.initializeSelectedAttachments();
                this.changeDetection.detectChanges();
            }
        })
            .catch((res) => {
        });
    }
    onBtnRemoveClicked() {
        if (this.selectedAttachments.length === 0) {
            this.appControllerService.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
            return;
        }
        if (this.selectedAttachments.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.options);
            dialogRef.componentInstance.title =
                AttachmentManagerConstants.DELETE_ATTACHMENT_TITLE;
            dialogRef.componentInstance.contentMessage =
                AttachmentManagerConstants.DELETE_REPORT_CONFIRM;
            dialogRef.componentInstance.data = this.selectedAttachments;
            dialogRef.result
                .then((refreshItems) => {
                if (refreshItems) {
                    this.removeAttachment();
                }
            })
                .catch((res) => {
            });
        }
    }
    setDataSource() {
        this.removeAllAttachmentsFromForm();
        const newImmutable = new Array();
        this.selectedSavedAttachments.forEach((el) => {
            newImmutable.push(new AttachemntMngView(el, this.datePipe));
            const form = AttachmentManagerHelper.createFormGroup(el, this.formBuilder);
            this.attachmentArrayCtrl.push(form);
        });
        this.dataSource$ = of(newImmutable);
        this.changeDetection.detectChanges();
    }
    listenForNewAttachments() {
        this.listenForNewAttachmentsSubscription =
            this.attachmentManagerService.emitSelectedSavedAttachment
                .subscribe((attachment) => {
                this.addSelectedSavedAttachment(true, attachment);
                this.changeDetection.detectChanges();
            });
    }
    listenForAttachmentListUpdate() {
        this.listenForAttachmentListUpdateSubscription =
            this.attachmentManagerService.emitListUpdated
                .subscribe((attachments) => {
                this.selectedSavedAttachments.forEach(x => {
                    const foundattachement = attachments.find(a => a.id == x.id);
                    if (foundattachement == null) {
                        const index = this.selectedSavedAttachments.findIndex(b => b.id == x.id);
                        this.selectedSavedAttachments.splice(index, 1);
                    }
                });
                this.setDataSource();
            });
    }
    cleanAttachment() {
        this.emitClearAttachmentTable = this.attachmentManagerService.emitClearAttachmentTable.subscribe(x => {
            if (x) {
                this.resetAttachmentTable();
                this.value = null;
            }
        });
    }
    downloadFile(attachmentId, fileName) {
        this.getAttachmentContentSubscription =
            this.attachmentManagerService.getAttachmentContent(attachmentId)
                .subscribe({
                next: (response) => {
                    FileUtils.openFile(fileName, response);
                },
                error: (error) => {
                    this.appControllerService.handleServerErrorMessage(AttachmentManagerConstants.ATTACHMENT_MANAGER_COMPONENT, error, CRUDOperation.Get);
                }
            });
    }
    removeAttachment() {
        this.selectedAttachments.forEach((element) => {
            const index = this.selectedSavedAttachments.findIndex((el) => el.id === element.id);
            this.selectedSavedAttachments.splice(index, 1);
        });
        this.setDataSource();
        this.initializeSelectedAttachments();
        this.appControllerService.showMessage(SharedConstants.REMOVE_SUCCESS, AlertType.Success);
        this.changeDetection.detectChanges();
    }
    removeDetachmentSubscriber() {
    }
    addSelectedSavedAttachment(fromComboBox, ...attachments) {
        let existingAttachments;
        attachments.forEach((attachment) => {
            existingAttachments = this.selectedSavedAttachments.find((el) => el.id === attachment.id);
            if (this.anonymousAccess.allDocumentsSelectedAnonymousAccess) {
                attachment.allowAccess = true;
            }
            attachment.link = {
                address: "/module",
                text: AttachmentManagerConstants.DOWNLOAD_LBL,
                clickAction: (link) => {
                    this.downloadFile(attachment.id, attachment.fileName);
                },
            };
            existingAttachments = this.replaceAttachmentExisting(fromComboBox, existingAttachments, attachment);
        });
        if (existingAttachments) {
            this.manageExistingAttachment(fromComboBox, existingAttachments);
            return;
        }
        this.selectedSavedAttachments.push(...attachments);
        this.setDataSource();
    }
    manageExistingAttachment(fromComboBox, existingAttachments) {
        if (fromComboBox) {
            this.appControllerService.showMessage(`${existingAttachments.fileName} ${AttachmentManagerConstants.EXISTING_ATTACHMENT}`, AlertType.Warning);
        }
        else {
            const index = this.selectedSavedAttachments.findIndex((el) => el.id === existingAttachments.id);
            this.selectedSavedAttachments[index] = existingAttachments;
            this.setDataSource();
        }
    }
    // tslint:disable-next-line:max-line-length
    replaceAttachmentExisting(fromComboBox, existingAttachments, newAttachments) {
        if (!fromComboBox) {
            if (existingAttachments) {
                existingAttachments = newAttachments;
                return existingAttachments;
            }
        }
        return existingAttachments;
    }
    initializeSelectedSavedAttachments() {
        this.selectedSavedAttachments = new Array();
    }
    initializeSelectedAttachments() {
        this.selectedAttachments = new Array();
    }
    removeAllAttachmentsFromForm() {
        while (this.attachmentArrayCtrl.controls.length > 0) {
            this.attachmentArrayCtrl.removeAt(0);
        }
    }
    resetAttachmentTable() {
        if (this.selectedSavedAttachments && this.selectedSavedAttachments.length > 0) {
            const count = this.selectedSavedAttachments.length;
            this.selectedSavedAttachments.splice(0, count);
            this.setDataSource();
            this.initializeSelectedAttachments();
            this.changeDetection.detectChanges();
        }
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        if (value) {
            this.value = value;
        }
        if (value === null) {
            this.resetAttachmentTable();
            this.attachmentListForm.reset();
            this.attachmentManagerService.emitClearAttachment.emit(true);
        }
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    validate(_) {
        return this.attachmentListForm.valid ? null : { profile: { valid: false } };
    }
    onSelectAllowAnonymousAccess($event, data) {
        const allowAccess = $event.target.checked;
        if (allowAccess) {
            data.allowAccess = true;
        }
        else {
            data.allowAccess = false;
        }
        this.attachmentListForm.value.attachmentList.forEach((attachment) => {
            if (attachment.id == data.id) {
                attachment.allowAccess = data.allowAccess;
            }
        });
        this.changeDetection.detectChanges();
    }
    static ctorParameters = () => [
        { type: AttachmentManagerService },
        { type: AppControllerService },
        { type: NgbModal },
        { type: DatePipe },
        { type: ChangeDetectorRef },
        { type: FormBuilder }
    ];
    static propDecorators = {
        componentType: [{ type: Input }],
        attachmentType: [{ type: Input }],
        jobId: [{ type: Input }],
        hideAddAttachmentButton: [{ type: Input }],
        hideDeleteAttachmentButton: [{ type: Input }],
        anonymousAccess: [{ type: Input }]
    };
};
AttachmentMngListComponent = __decorate([
    Component({
        selector: "app-attachment-mng-list",
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AttachmentMngListComponent),
                multi: true,
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => AttachmentMngListComponent),
                multi: true,
            },
        ],
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AttachmentMngListComponent);
export { AttachmentMngListComponent };
